import getSdkSession from './utils/getSdkSession';

import account from './account';
import bam from './identity/bam';
import external from './identity/external';
import profile from './profile';
import session from './session';
import subscription from './subscription';
import token from './token';

class UserManager {

    constructor() {

        this.account = account;
        this.bam = bam;
        this.external = external;
        this.getSdkSession = getSdkSession;
        this.profile = profile;
        this.session = session;
        this.subscription = subscription;
        this.token = token;

    }

}

const instance = new UserManager();

export default instance;
